module.exports = __webpack_public_path__ + "img/LOGO KUBOTA 2018 (2).5804fe6c.png";